<template>
<div class="chapter">
<div class="inner_page">
<p class="half-title"><a id="page_i"></a>LAST DOG<br/>ON THE HILL</p>
<p class="image"><img alt="Images" src="images/role.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half-title.vue?0d97cc6a